export const statusTranslations = {
  en: {
    new: "New",
    picked: "Picked",
    accepted: "Accepted",
    delivered: "Delivered",
    cancelled: "Cancelled",
    postponed: "Postponed",
  },
  no: {
    new: "Ny",
    picked: "Plukket opp",
    accepted: "Akseptert",
    delivered: "Levert",
    cancelled: "Kansellert",
    postponed: "Utsatt",
  },
};
